export default "__VITE_ASSET__BbpHNgK9__"